import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-068962ba"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "edithuiyuan"
};
const _hoisted_2 = {
  class: "myform"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("上级");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("名称");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("登录密码");

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "  登录密码必需包含大小写字母和数字，最少8位", -1));

const _hoisted_7 = /*#__PURE__*/_createTextVNode("现金模式");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("开启");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("关闭");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("额度模式");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("现金");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("信用");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("彩种选择");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("快彩");

const _hoisted_15 = /*#__PURE__*/_createTextVNode("香港六合");

const _hoisted_16 = /*#__PURE__*/_createTextVNode("澳门六合");

const _hoisted_17 = /*#__PURE__*/_createTextVNode("新澳门六合");

const _hoisted_18 = /*#__PURE__*/_createTextVNode("盘口(快彩)");

const _hoisted_19 = /*#__PURE__*/_createTextVNode("A盘");

const _hoisted_20 = /*#__PURE__*/_createTextVNode("B盘");

const _hoisted_21 = /*#__PURE__*/_createTextVNode("C盘");

const _hoisted_22 = /*#__PURE__*/_createTextVNode("盘口(六合)");

const _hoisted_23 = /*#__PURE__*/_createTextVNode("A盘");

const _hoisted_24 = /*#__PURE__*/_createTextVNode("B盘");

const _hoisted_25 = /*#__PURE__*/_createTextVNode("C盘");

const _hoisted_26 = /*#__PURE__*/_createTextVNode("状态");

const _hoisted_27 = /*#__PURE__*/_createTextVNode("启用");

const _hoisted_28 = /*#__PURE__*/_createTextVNode("停用");

const _hoisted_29 = /*#__PURE__*/_createTextVNode("冻结");

const _hoisted_30 = /*#__PURE__*/_createTextVNode("确认修改");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_input = _resolveComponent("el-input");

  const _component_warning_filled = _resolveComponent("warning-filled");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_el_popover = _resolveComponent("el-popover");

  const _component_el_radio = _resolveComponent("el-radio");

  const _component_el_radio_group = _resolveComponent("el-radio-group");

  const _component_el_checkbox = _resolveComponent("el-checkbox");

  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($data.user_data.pre_user_info.username), 1)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.userinfo.sub_group_name) + "账号", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.userinfo.username), 1)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_4]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        visible: $data.err.nickname.visible,
        placement: "right"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "140px"
          },
          modelValue: $data.nickname,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.nickname = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          placeholder: "请输入",
          clearable: "",
          onFocus: _cache[1] || (_cache[1] = $event => $data.err.nickname.visible = false)
        }, null, 8, ["modelValue"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.nickname.content), 1)])]),
        _: 1
      }, 8, ["visible"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_5]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        visible: $data.err.pwd.visible,
        placement: "right"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "140px"
          },
          modelValue: $data.pwd.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.pwd.value = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          placeholder: "留空表示不修改密码",
          clearable: "",
          onFocus: _cache[3] || (_cache[3] = $event => $data.err.pwd.visible = false),
          "show-password": "",
          type: "password",
          autocomplete: "new-password"
        }, null, 8, ["modelValue"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.pwd.content), 1)])]),
        _: 1
      }, 8, ["visible"]), _hoisted_6]),
      _: 1
    })]),
    _: 1
  }), _ctx.$store.state.userinfo.group_id == 1 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_7]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.transfer_status,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.transfer_status = $event),
        onChange: _cache[5] || (_cache[5] = $event => $data.is_extract = $data.transfer_status == '0' ? '1' : '0')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "0"
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_10]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.bill_reset,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.bill_reset = $event)
      }, {
        default: _withCtx(() => [$data.user_data.pre_user_info.bill_reset == '1' || $data.user_data.pre_user_info.bill_reset == '0' ? (_openBlock(), _createBlock(_component_el_radio, {
          key: 0,
          label: "0"
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        })) : _createCommentVNode("", true), $data.user_data.pre_user_info.bill_reset == '1' || $data.user_data.pre_user_info.bill_reset == '2' ? (_openBlock(), _createBlock(_component_el_radio, {
          key: 1,
          label: "2"
        }, {
          default: _withCtx(() => [_hoisted_12]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_13]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
        modelValue: $data.user_play_status_list,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.user_play_status_list = $event),
        onChange: $options.change_user_play_status_list
      }, {
        default: _withCtx(() => [$data.user_data.pre_user_info.status_kuaicai == 1 ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 0,
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        })) : _createCommentVNode("", true), $data.user_data.pre_user_info.status_liuhe == 1 ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 1,
          label: "2"
        }, {
          default: _withCtx(() => [_hoisted_15]),
          _: 1
        })) : _createCommentVNode("", true), $data.user_data.pre_user_info.status_aomen == 1 ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 2,
          label: "3"
        }, {
          default: _withCtx(() => [_hoisted_16]),
          _: 1
        })) : _createCommentVNode("", true), $data.user_data.pre_user_info.status_xinaomen == 1 ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 3,
          label: "4"
        }, {
          default: _withCtx(() => [_hoisted_17]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "onChange"])]),
      _: 1
    })]),
    _: 1
  }), $data.user_play_status_list.includes('1') ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$data.user_data.pre_user_info.occupy_status == 1 && $data.occupy_status == 1 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.userinfo.sup_group_name) + "保留占成(快彩)", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        visible: $data.err.kuaicai_sup_occupy_lock.visible,
        placement: "right"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "140px"
          },
          modelValue: $data.kuaicai_sup_occupy_lock,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.kuaicai_sup_occupy_lock = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          onFocus: _cache[9] || (_cache[9] = $event => $data.err.kuaicai_sup_occupy_lock.visible = false),
          disabled: $data.user_data.pre_user_info.group_id < 2
        }, null, 8, ["modelValue", "disabled"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.kuaicai_sup_occupy_lock.content), 1)])]),
        _: 1
      }, 8, ["visible"]), _createElementVNode("span", null, "  最高可设占成" + _toDisplayString($data.user_data.pre_user_info.kuaicai_max_sup_lock) + "%", 1)]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_18]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.kuaicai_userKind_kc,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.kuaicai_userKind_kc = $event)
      }, {
        default: _withCtx(() => [$data.user_data.pre_user_info.kuaicai_level_id.includes('0') || $data.user_data.pre_user_info.kuaicai_level_id.includes('1') ? (_openBlock(), _createBlock(_component_el_radio, {
          key: 0,
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_19]),
          _: 1
        })) : _createCommentVNode("", true), $data.user_data.pre_user_info.kuaicai_level_id.includes('0') || $data.user_data.pre_user_info.kuaicai_level_id.includes('2') ? (_openBlock(), _createBlock(_component_el_radio, {
          key: 1,
          label: "2"
        }, {
          default: _withCtx(() => [_hoisted_20]),
          _: 1
        })) : _createCommentVNode("", true), $data.user_data.pre_user_info.kuaicai_level_id.includes('0') || $data.user_data.pre_user_info.kuaicai_level_id.includes('3') ? (_openBlock(), _createBlock(_component_el_radio, {
          key: 2,
          label: "3"
        }, {
          default: _withCtx(() => [_hoisted_21]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })], 64)) : _createCommentVNode("", true), $data.user_play_status_list.includes('2') || $data.user_play_status_list.includes('3') || $data.user_play_status_list.includes('4') ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [$data.user_data.pre_user_info.occupy_status == 1 && $data.occupy_status == 1 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.userinfo.sup_group_name) + "保留占成(六合)", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        visible: $data.err.sup_occupy_lock.visible,
        placement: "right"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "140px"
          },
          modelValue: $data.sup_occupy_lock,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.sup_occupy_lock = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          onFocus: _cache[12] || (_cache[12] = $event => $data.err.sup_occupy_lock.visible = false),
          disabled: $data.user_data.pre_user_info.group_id < 2
        }, null, 8, ["modelValue", "disabled"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.sup_occupy_lock.content), 1)])]),
        _: 1
      }, 8, ["visible"]), _createElementVNode("span", null, "  最高可设占成:" + _toDisplayString($data.user_data.pre_user_info.max_sup_lock * 1) + "%", 1)]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_22]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
        modelValue: $data.userKind_kc,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.userKind_kc = $event)
      }, {
        default: _withCtx(() => [$data.user_data.pre_user_info.level_id.includes('0') || $data.user_data.pre_user_info.level_id.includes('1') ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 0,
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_23]),
          _: 1
        })) : _createCommentVNode("", true), $data.user_data.pre_user_info.level_id.includes('0') || $data.user_data.pre_user_info.level_id.includes('2') ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 1,
          label: "2"
        }, {
          default: _withCtx(() => [_hoisted_24]),
          _: 1
        })) : _createCommentVNode("", true), $data.user_data.pre_user_info.level_id.includes('0') || $data.user_data.pre_user_info.level_id.includes('3') ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 2,
          label: "3"
        }, {
          default: _withCtx(() => [_hoisted_25]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_26]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.userState,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.userState = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_27]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "0"
        }, {
          default: _withCtx(() => [_hoisted_28]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "2"
        }, {
          default: _withCtx(() => [_hoisted_29]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })]), _createVNode(_component_el_button, {
    style: {
      "margin-top": "10px"
    },
    type: "primary",
    size: "small",
    onClick: $options.post_change
  }, {
    default: _withCtx(() => [_hoisted_30]),
    _: 1
  }, 8, ["onClick"])]);
}